import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Star16(_ref) {
  var gradient = _ref.gradient,
    fill = _ref.fill;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/forbid-elements
    _jsxs("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [gradient, /*#__PURE__*/_jsx("path", {
        fill: fill,
        d: "M8.70073 0.478856C8.44948 -0.159619 7.55052 -0.159619 7.29927 0.478856L5.65693 4.65232C5.55165 4.91985 5.30469 5.10433 5.0195 5.1285L0.691328 5.49524C0.0338335 5.55095 -0.239973 6.369 0.250304 6.81289L3.60243 9.84782C3.80517 10.0314 3.89336 10.3108 3.833 10.5782L2.81869 15.0725C2.66947 15.7337 3.39328 16.2438 3.9608 15.8775L7.59279 13.5328C7.84088 13.3726 8.15912 13.3726 8.40721 13.5328L12.0392 15.8775C12.6067 16.2438 13.3305 15.7337 13.1813 15.0725L12.167 10.5782C12.1066 10.3108 12.1948 10.0314 12.3976 9.84782L15.7497 6.81289C16.24 6.369 15.9662 5.55095 15.3087 5.49524L10.9805 5.1285C10.6953 5.10433 10.4483 4.91985 10.3431 4.65232L8.70073 0.478856Z"
      })]
    })
  );
}